
<template>

	<mymodal ref="modal" :title="title" ok="Импортировать" :reset="reset" :check="check" :submit="submit" width="1000px" :ok_hide="false">

		<b-overlay :show="wait">

			<b-form-file id="fl_input" :state="fl_state" v-model="fl" placeholder="Файл" v-on:change="load_file" accept=".xml"/>
			<b-form-invalid-feedback :state="fl_state">Необходимо указать файл</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="fl_state" :state="fl_has_attrs_state">Некорректный файл или в файле отсутствуют ценообразующие факторы</b-form-invalid-feedback>

			<b-form-group class="mt-2" label="Соответствия ценообразующих факторов" label-for="attr_selects">

				<b-form-row no-gutters>

					<b-col cols="5" sm="5"><v-select :state="attr_fd_state" :clearable="false" v-model="attr_fd" :options="attrs_fd_visible" label="name" :reduce="obj => obj.id" clearSearchOnSelect required appendToBody v-on:input="select_attr_fd"/></b-col>
					<b-col cols="1" sm="1" align="center">-></b-col>
					<b-col cols="4" sm="5"><v-select :state="attr_state" :clearable="false" v-model="attr" label="name" :reduce="obj => obj.id" :options="attrs_visible" clearSearchOnSelect required appendToBody :disabled="attr_fd == null"/></b-col>

					<b-col cols="1" align="right" sm>

						<b-button variant="light" class="filter-button" v-on:click="add_connection"><b-icon-plus/></b-button>
						<b-button v-if="selected_connections.length" variant="light" class="filter-button" v-on:click="delete_connections"><b-icon icon="trash"/></b-button>

					</b-col>

				</b-form-row>

				<b-form-row no-gutters>

					<b-table striped hover :items="this.connections" :fields="connections_fields" sort-by="date" selectable selected-variant="danger" v-on:row-selected="select_connection"/>

				</b-form-row>

			</b-form-group>

		</b-overlay>

	</mymodal>

</template>

<script>

import api from "../../../api"
import attrs from "../../../api/attrs"
import mymodal from "../../widgets/modal"

export default
{
	props :
	{
		group_id : String,
		service : String,
		title : { type : String, default : () => "Импорт" },
		only_real_attrs : { type : Boolean, default : () => false },
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			fl : null,
			fl_state : null,
			fl_has_attrs_state : null,

			attrs : [],
			attrs_fd : [],
			attrs_visible : [],
			attrs_fd_visible : [],

			attr : null,
			attr_fd : null,

			attr_state : null,
			attr_fd_state : null,

			connections : [],
			connections_fields :
			[
				{
					key : "attr_fd",
					label : "Файл",
					formatter : attr_fd => attr_fd.name
				},
				{
					key : "attr",
					label : "НСПД",
					formatter : attr => attr.name
				},
			],
			selected_connections : [],

			wait : false,
			
			formula: null,

		}
	},

	methods :
	{
		reset()
		{
			this.fl = null
			this.fl_state = null
			this.fl_has_attrs_state = null
			this.attrs_fd = []
			this.attrs = []
			this.attrs_fd_visible = []
			this.attrs_visible = []
			this.attr_fd_state = null
			this.attr_state = null
			this.attr_fd = null
			this.attr = null
			this.connections = []
			this.selected_connections = []
			this.from_row = null
			this.to_row = null
			this.wait = false

			attrs.get(this).then(
				desc =>
				{
					this.attrs = api.deep_clone(api.sort_objects_array_by_key(desc.attrs.filter(attr =>
						( ! this.only_real_attrs || attr.real )
						&&
						attr.key != "attrs.bad"
						), "name"))
					this.attrs.forEach(attr => { attr.visible = null })

					this.refresh_visible_attrs()
				})
		},

		check()
		{
			this.fl_state = !! this.fl
			this.fl_has_attrs_state = this.attrs_fd.length > 0

			return this.fl_state && this.fl_has_attrs_state && ( this.attrs_fd_visible.length == 0 )
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		load_file(event)
		{
			if(event.target.files)
			{				
				const reader = new FileReader()
			
				reader.readAsText(event.target.files[0])
				reader.onloadend = 
					() =>
					{
						const parser = new DOMParser()
						var xmlDoc = parser.parseFromString(reader.result,"text/xml")
						// this.formula = xmlDoc.getElementsByTagName("Rating_Model")[0].innerHTML

						var raw_ids = document.evaluate(
							'//FD_State_Cadastral_Valuation/Package/Appraise/Statistical_Modelling/Group_Real_Estate_Modelling/Evaluative_Factors_Modelling/Evaluative_Factor_Modelling/@Id_factor',
							xmlDoc,
							null,
							XPathResult.UNORDERED_NODE_ITERATOR_TYPE,
							null
						)

						const ef_ids = []

						try {
							let thisNode = raw_ids.iterateNext();

							while (thisNode) {
								ef_ids.push(thisNode.nodeValue)
								thisNode = raw_ids.iterateNext();
							}
						} catch (e) {
							console.error(`Error: Document tree modified during iteration ${e}`);
						}
						
						var raw_efs = document.evaluate(
							'//FD_State_Cadastral_Valuation/Package/Evaluative_Factors/Evaluative_Factor',
							xmlDoc,
							null,
							XPathResult.UNORDERED_NODE_ITERATOR_TYPE,  
							null
						)

						const ef_names = []

						try {
							let thisNode = raw_efs.iterateNext();      

							while (thisNode) {
								if (ef_ids.includes(thisNode.getAttribute("Id_Factor")))
									ef_names.push({
										name : thisNode.getElementsByTagName("Name_Factor")[0].innerHTML,
										is_quantative : thisNode.getAttribute("Type") == "2",
										id : thisNode.getAttribute("Id_Factor"),
									})
							thisNode = raw_efs.iterateNext();        
							}
						} catch (e) {
							console.error(`Error: Document tree modified during iteration ${e}`);
						}
                                                
						this.attrs_fd = ef_names
						this.connections = []
						this.selected_connections = []
						this.attr = null
						this.attr_fd = null

						this.attrs.forEach(
							attr =>
							{
								attr.visible = null 
								attr.has_connection = false
							})

						this.refresh_visible_attrs()
					}
			}	
		},

		select_attr_fd(id)
		{
			const attr_fd = this.attrs_fd.find(attr_fd => attr_fd.id == id)

			if(attr_fd.is_quantative)
				this.attrs.forEach(
					attr =>
					{
						attr.visible = ( attr.type == "number" && ! attr.has_connection )
					})
			else
				this.attrs.forEach(
					attr =>
					{
						attr.visible = ( attr.type == "str" && attr.reference != null && ! attr.has_connection )
					})

			this.attr = null

			this.refresh_visible_attrs()
		},

		refresh_visible_attrs()
		{
			var attrs_visible = this.attrs.filter(attr => attr.visible || attr.visible == null)
			var attrs_fd_visible = this.attrs_fd.filter(attr => attr.visible || attr.visible == null)

			this.attrs_visible = attrs_visible
			this.attrs_fd_visible = attrs_fd_visible
		},

		add_connection()
		{
			this.attr_state = ( this.attr != null )
			this.attr_fd_state = ( this.attr_fd != null )

			if(! ( this.attr_fd_state && this.attr_state ) )
				return

			const attr_fd_ind = this.attrs_fd.findIndex(elem => elem.id == this.attr_fd)
			const attr_fd_name = this.attrs_fd[attr_fd_ind].name
			const attr_ind = this.attrs.findIndex(elem => elem.id == this.attr)
			const attr_id = this.attrs[attr_ind]

			this.attrs_fd[attr_fd_ind].visible = false
			this.attrs[attr_ind].visible = false
			this.attrs[attr_ind].has_connection = true
			this.refresh_visible_attrs()

			this.connections.push({ attr_fd : { name : attr_fd_name, id : this.attr_fd }, attr_fd_ind : attr_fd_ind, attr : attr_id, attr_ind : attr_ind })

			this.attr_fd = null
			this.attr = null
		},

		select_connection(selected)
		{
			this.selected_connections = selected
		},

		delete_connections()
		{
			this.selected_connections.forEach(
				selected_conn =>
				{
					const index = this.connections.findIndex(conn => conn.attr_ind == selected_conn.attr_ind)

					this.attrs_fd[selected_conn.attr_fd_ind].visible = true
					this.attrs[selected_conn.attr_ind].visible = true
					this.attrs[selected_conn.attr_ind].has_connection = false
					this.connections.splice(index, 1)
				})

			this.selected_connections = []
			this.attr = null
			this.attr_fd = null

			this.refresh_visible_attrs()
		},

		submit()
		{
			this.wait = true

			var connections = {}

			this.connections.forEach(elem => { connections[elem.attr_fd.id] = elem.attr.id })

			const reader = new FileReader()

			reader.onload =
				fl =>
					api.upload_file(this, fl, this.fl.name, this.fl.name,
						response =>
						{
							api.call_long_operation(this, this.title, "cadastral_groups", "load_from_fd", { id : this.group_id, fl : response.id, factors_to_attrs : connections },
								() =>
								{
									api.delete_file(this, response.id)

									this.$emit("need_refresh")

								})

							this.wait = false

							this.$refs.modal.my_hide()
						})
			
			reader.readAsBinaryString(this.fl)
		},
	}
}

</script>

